import React from 'react';
// eslint-disable-next-line import/namespace
import { Redirect, Route, RouteProps } from 'react-router-dom';

import pathnames from './pathnames';

const RouteWithRedirect = (props: RouteProps & { enabled?: boolean }) => (
  <Route
    {...props}
    {...(props.enabled ?? true
      ? {}
      : { render: () => <Redirect to={pathnames.notFound()} /> })}
  />
);

export default RouteWithRedirect;
